import { render, staticRenderFns } from "./CardListProductPagesAccordion.vue?vue&type=template&id=5acfbf70&scoped=true"
import script from "./CardListProductPagesAccordion.vue?vue&type=script&lang=js"
export * from "./CardListProductPagesAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfbf70",
  null
  
)

export default component.exports